{
    "menu":{
        "realTime":"Tempo Real",
        "alerts":"Alertas",
        "history":"Histórico",
        "licensePlates":"Cadastro de Alertas",
        "events":"Eventos",
        "tooltip":{
            "alertHistory":"Histórico",
            "plateRegistration":"Cadastro de Alertas"
        }
    },
    "headerMenu":{
        "logOut":"Sair",
        "changePassword":"Alterar Senha",
        "languageOptions":{
            "portuguese":"Português",
            "spanish":"Espanhol",
            "english":"Inglês"
        }
    },
    "shared":{
        "filter":{
            "filterLabel":"Filtrar",
            "filterCleanLabel":"Limpar filtros",
            "filterMostRecent":"Mais Recentes",
            "filterSelectOption":"Selecione uma opção",
            "filterOlder":"Mais Antigos",
            "filterPlate":"Placa",
            "filterEquipment":"Equipamento",
            "filterAlertType":"Tipo Alerta",
            "filterShowAll":"Mostrar todos",
            "registrationDate":"Data Cadastro",
            "deadline":"Prazo",
            "filterSelectedAlertType":"motivo selecionado",
            "filterSelectedAlertsType":"motivos selecionados"
        },
        "placeholder":{
            "select":"Selecionar",
            "selectDeadline":"Selecione um prazo"
        },
        "details":{
            "detailsTitle":"Detalhes do Alerta",
            "remarks":"Observações",
            "save":"Salvar"
        },
        "table":{
            "detail":"Detalhar",
            "pageReport":"Mostrando {first} a {last} de {totalRecords} registros"
        },
        "labels":{
            "alertsLabel":" alertas",
            "motiveLabels":{
                "licensingDelay":"Atraso Licenciamento",
                "crime":"Crime",
                "ipvaDelay":"Atraso IPVA",
                "boxTruck":"Baú",
                "tankWithLiquids":"Tanque com Líquidos",
                "concretePipe":"Manilha",
                "metal":"Metal",
                "stone":"Pedra",
                "logOfWood":"Tora de Madeira",
                "wood":"Madeira",
                "brick":"Tijolo",
                "rockParticles":"Partículas de Rochas",
                "glass":"Vidro",
                "gasCylinder":"Botijão de Gás",
                "dumpster":"Caçamba",
                "container":"Container"
            },
            "alert":"Alerta",
            "plate":"Placa",
            "dateAndHour":"Data e Hora",
            "registrationDate":"Data Cadastro",
            "location":"Local",
            "address":"Endereço",
            "direction":"Sentido",
            "lane":"Pista",
            "equipment":"Equipamento",
            "plateRule":"Regra da Placa",
            "weight":"Peso",
            "userFeedback":"Usuário Feedback",
            "reason":"Motivo",
            "deadline":"Prazo",
            "status":"Situação",
            "interval":"Intervalo",
            "register":"Cadastrar",
            "confirmation":"Confirmação",
            "name":"Nome",
            "yes":"Sim",
            "no":"Não",
            "confirm":"Confirmar",
            "cancel":"Cancelar",

            "brand":"Marca",
            "model":"Modelo",
            "city":"Cidade",
            "color":"Cor",
            "state":"Estado",
            "disabled":"Inativo",
            "publicSecurityIntegration":"Integração Segurança Pública",
            "confiability":"Confiabilidade",
            "ia-load":"IA Carga",
            "ia-helmet":"IA Capacete",
            "ia-classification":"IA Classificação",
            "ia-metadados":"Metadados"
        }
    },
    "calendar": {
        "dayNames": {
          "sunday": "Domingo",
          "monday": "Segunda",
          "tuesday": "Terça",
          "wednesday": "Quarta",
          "thursday": "Quinta",
          "friday": "Sexta",
          "saturday": "Sábado"
        },
        "dayNamesShort": {
          "sun": "Dom",
          "mon": "Seg",
          "tue": "Ter",
          "wed": "Qua",
          "thu": "Qui",
          "fri": "Sex",
          "sat": "Sab"
        },
        "dayNamesMin": {
          "su": "Dom",
          "mo": "Seg",
          "tu": "Ter",
          "we": "Qua",
          "th": "Qui",
          "fr": "Sex",
          "sa": "Sab"
        },
        "monthNames": {
          "january": "Janeiro",
          "february": "Fevereiro",
          "march": "Março",
          "april": "Abril",
          "may": "Maio",
          "june": "Junho",
          "july": "Julho",
          "august": "Agosto",
          "september": "Setembro",
          "october": "Outubro",
          "november": "Novembro",
          "december": "Dezembro"
        },
        "monthNamesShort": {
          "jan": "Jan",
          "feb": "Fev",
          "mar": "Mar",
          "apr": "Abr",
          "may": "Mai",
          "jun": "Jun",
          "jul": "Jul",
          "aug": "Ago",
          "sep": "Set",
          "oct": "Out",
          "nov": "Nov",
          "dec": "Dez"
        },
        "dateFormat": "dd/mm/yy",
        "emptyMessage": "Sem Resposta"
    },
    "login":{
        "subTitle":"Vigilancia ativa para cidades inteligentes",
        "password":"Senha",
        "logIn":"Entrar",
        "loginError":"Falha ao realizar login",

        "authServerCommunicationFail": "Falha de comunicação com o servidor de autenticação.",
        "invalidRequest": "Requisição inválida. Verifique os dados informados.",
        "invalidCredentials": "E-mail ou senha incorretos.",
        "noPermissionAdmin": "Usuário sem permissão para acessar o Administrador.",
        "authInternalError": "Erro interno no serviço de autenticação.",
        "authServiceUnavailable": "Serviço de autenticação temporariamente indisponível."
        
    },
    "realTime":{
        "empty_1": "Selecione em",
        "empty_2": "a(s) câmera(s) desejada(s) para exibir o streaming de video",
        "toolbar":{
            "videoWallTooltip":"Visualizar o video wall em tela cheia",
            "showInfoTooltip":"Mostrar/Esconder barra de informações das cameras",
            "videoWallConfig":"Configurações do video wall",
            "videoWallOneDevice":"Alterar video wall para 1 dispositivo",
            "videoWallFourDevices":"Alterar video wall para 4 dispositivos",
            "info":"Selecione um ou mais dispositivos para ativar as ações",
            "videoWallConfigModal":{
                "title":"Configurações do Video Wall",
                "rotate":"Rotacionar",
                "seconds":"Segundos",
                "update":"Atualizar"
            }
        },
        "deviceSideBar":{
            "selected":"Selecionado(s):",
            "cameras":"Câmeras"
        },
        "groupSideBar":{
            "new":"Novo",
            "editGroup":"Editar grupo",
            "removeGroup":"Remover grupo",
            "addOrRemove":"Adicionar/Remover do carrossel",
            "toast":{
                "successGroupRegistered":"Grupo cadastrado com sucesso",
                "dywRemoveGroup":"Deseja realmente remover o grupo?",
                "successGroupDeleted":"Grupo excluído com sucesso",
                "successGroupEdited":"Grupo editado com sucesso",
                "successDeviceDeleted":"Dispositivo excluído com sucesso"
            },
            "createOrEditModal":{
                "newGroup":"Novo Grupo",
                "editGroup":"Editar Grupo"
            }
        },
        "buttons": {
            "devices":"Dispositivos",
            "devicesTooltip":"Selecionar dispositivos",
            "groups":"Grupos",
            "selectGroups":"Selecionar grupos"
        },
        "toast":{
            "infoTitle":"Informação",
            "minimalDevices":"Esta configuração será disponibilizada quando for selecionado no mínimo 5 dispositivos",
            "disabledF11":"O botão \"F11\" que executa a função tela cheia foi desabilitada nesta página, para visualizar o video wall em tela cheia clique no botão sinalizado"
        }
    },
    "alert":{
        "toolbar":{
            "noneAlert":"Nenhum alerta ativo",
            "activeAlert":" Alerta ativo",
            "activeAlerts":" Alertas ativos",
            "pauseTooltip":"Pausar a atualização de novos alertas em tela",
            "startTooltip":"Retomar a atualização de novos alertas em tela"
        },
        "toast":{
            "attentionTitle":"Atenção!",
            "errorTitle":"Erro!",
            "successTitle":"Sucesso!",
            "warnTitle":"Aviso!",
            "noAlert":"Nenhum alerta encontrado",
            "errorGetAlert":"Falha ao buscar a lista de alertas",
            "errorGetMotive":"Erro ao buscar motivos",
            "feedbackError": "Para enviar um feedback é necessário informar o motivo",
            "feedbackSuccess":"Feedback enviado"
        }
    },
    "alertHistory":{
        "toolbar":{
            "alertHistory":"Histórico"
        }
    },
    "plates":{
        "toolbar":{
            "licensePlateRegistration":"Cadastro de Alertas",
            "uploadTooltip":"Anexar arquivo de alertas"
        },
        "toast":{
            "errorGetPlate":"Erro ao buscar alertas!",
            "fourAsterisksError":"Não são permitidos mais de 4 asteriscos",
            "validPlateError":"Digite uma placa válida",
            "oneOrMoreReasonsError":"Selecione um ou mais motivos",
            "noDeadlineError":"Selecione um prazo",
            "getRulesError":"Erro ao buscar regras existentes",
            "importSuccess":"Alertas importadas com sucesso!",
            "somePlates":"Algumas alertas não foram importadas!",
            "errorImportingPlates":"Erro ao importar alertas!",
            "requestError":"Erro na requisição"
        },
        "registerDialog":{
            "dywRegister":"Deseja cadastrar a placa {{plate}} com {{theReasons}}",
            "theReason":" o motivo",
            "theReasons":" os motivos",
            "and":" e ",
            "withinPeriod":" no prazo ",
            "plateRegistered":"Placa {{plate}} com {{theReasons}}",
            "successRegistered":" cadastrada com sucesso!",
            "registerError":"Erro ao cadastrar placa!",
            "alreadyAnActiveRule":"Já existe uma regra ativa para a placa {{plate}}, para o motivo {{reason}}, no período de {{startDate}} à {{endDate}}<br>Deseja Sobrescrever?",
            "operationCanceled":"Operação cancelada para a placa {{plate}}, motivo '{{reason}}'"
        },
        "uploadDialog":{
            "attachPlateFile":"Anexar arquivo de placas",
            "attentionFormat":"Atenção: o arquivo anexado deve seguir o padrão do arquivo exemplo",
            "buttons":{
                "choose":"Escolher",
                "cancel":"Cancelar",
                "exampleFile":"Arquivo Exemplo"
            },
            "uploadError":"Seu arquivo não foi aceito pelos seguintes erros listados abaixo. Por favor, corrija-os para que o upload seja feito com sucesso",
            "errorList":{
                "column":"Coluna ",
                "line":" Linha "
            }
        },
        "table":{
            "activeDialog":{
                "dywActive":"Deseja {{option}} a placa {{plate}}?",
                "activate":"ativar",
                "deactivate":"desativar",
                "activated":"ativada",
                "deactivated":"desativada",
                "activeSuccess":"Placa {{option}} com sucesso!",
                "activeError":"Erro ao {{option}} placa!"
            },
            "reasonDeactivation":"Motivo da desativação"
        }
    },
    "events":{
        "toolbar":{
            "events":"Eventos"
        },
        "details":{
            "detailsTitle":"Detalhes do Evento",
            "hasAlert":"Esta passagem possui alerta"
        },
        "toast":{
            "getEventError":"Erro ao buscar eventos!"
        }
    }
}
